import { ActionTypes } from '../types/actionTypes';

export interface ISupplier {
  index: number;
  inn: string;
  is_dishonest: boolean;
  is_msp: boolean;
  kpp: string;
  name: string;
  okpd2_codes: string[];
  regions: { code: string; name: string }[];
  registered_on_etp: boolean;
  relevance_raw_values: { procedure_bids_count_total: string; procedure_bids_count_won_total: string };
  short_name: string;
}

export interface ISupplierState {
  current_page: number;
  data: ISupplier[];
  last_page: number;
  per_page: number;
  total: number;
  searchId: number;
  errors: string;
}

const initialState = {} as ISupplierState;

export interface ISetSuppliers {
  type: typeof ActionTypes.SET_SUPPLIERS;
  payload: ISupplierState;
}

export interface ISetSuppliersPage {
  type: typeof ActionTypes.SET_SUPPLIERS_PAGE;
  payload: number;
}
export interface ISetSuppliersSearchId {
  type: typeof ActionTypes.SET_SUPPLIERS_SEARCH_ID;
  payload: number;
}

export interface ISetSuppliersSearchErrors {
  type: typeof ActionTypes.SET_SUPPLIERS_SEARCH_ERRORS;
  payload: string;
}

type TActionTypes = ISetSuppliers | ISetSuppliersPage | ISetSuppliersSearchId | ISetSuppliersSearchErrors;

export default function advancedSearch(state = initialState, action: TActionTypes) {
  switch (action.type) {
    case ActionTypes.SET_SUPPLIERS:
      return { ...state, ...action.payload };
    case ActionTypes.SET_SUPPLIERS_PAGE:
      return { ...state, current_page: action.payload };
    case ActionTypes.SET_SUPPLIERS_SEARCH_ID:
      return { ...state, searchId: action.payload };
    case ActionTypes.SET_SUPPLIERS_SEARCH_ERRORS:
      return { ...state, errors: action.payload };

    default:
      return state;
  }
}
